// export default function Servicos() {
//   const lista = [
//     { nome: "Manutenção preventiva", img: "/img/preventiva.png" },
//     { nome: "Troca de óleo", img: "/img/oleo.png" },
//     { nome: "Injeção eletrônica", img: "/img/injecao.png" },
//     { nome: "Diagnósticos Bosch", img: "/img/bosch.png" },
//     { nome: "Balanceamento", img: "/img/balanceamento.png" },
//     { nome: "Alinhamento", img: "/img/alinhamento.png" },
//   ];

//   return (
//     <section id="servicos" className="py-12 bg-gray-100 text-center">
//       <h3 className="text-2xl font-bold mb-6">Nossos Serviços</h3>
//       <ul className="grid gap-4 md:grid-cols-2 max-w-3xl mx-auto">
//         {lista.map((item, index) => (
//           <li key={index} className="bg-white pb-4 shadow rounded-lg flex flex-col items-center mx-auto w-80 sm:w-80 md:w-80">
//             <img src={item.img} alt={item.nome} className="w-full h-40 object-cover rounded-t-lg mb-3" />
//             <span className="text-sm md:text-base">{item.nome}</span>
//           </li>
//         ))}
//       </ul>
//     </section>
//   );
// }

export default function Servicos() {
  const lista = [
    { nome: "Manutenção preventiva", img: "/img/preventiva.png" },
    { nome: "Troca de óleo", img: "/img/oleo.png" },
    { nome: "Injeção eletrônica", img: "/img/injecao.png" },
    { nome: "Diagnósticos Bosch", img: "/img/bosch.png" },
    { nome: "Balanceamento", img: "/img/balanceamento.png" },
    { nome: "Alinhamento", img: "/img/alinhamento.png" },
  ];

  return (
    <section id="servicos" className="py-12 bg-gray-100 text-center">
      <h3 className="text-2xl font-bold mb-6">Nossos Serviços</h3>
      <ul className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3 max-w-6xl mx-auto px-4">
        {lista.map((item, index) => (
          <li key={index} className="bg-white pb-4 shadow rounded-lg flex flex-col items-center w-full">
            <div className="w-full aspect-video">
              <img src={item.img} alt={item.nome} className="w-full pb-5 h-full object-contain rounded-t-lg" />
            </div>
            <span className="text-sm sm:text-base">{item.nome}</span>
          </li>
        ))}
      </ul>
    </section>
  );
}
